export default "__VITE_ASSET__DVBoEVxK__"